import { useEffect, useState } from "react"
import { Event, FShift, GrouppedData, EventsCalculation, EventsCalculationItem } from "../../../types/types"
import { useScreenStore } from "../../../stores/ScreenStore"
import { useFetch } from "../../../hooks/useFetch"
import TimelineChart from "../../../components/Charts/TimelineChart/TimelineChart"
import { useAppStore } from "../../../stores/RootStore"
import { calculateEvents } from "../../../lib/calculations"
import { hexColor, rgbColor } from "../../../enums/colors"
import { Popover, PopoverContent, PopoverTrigger } from "../../../ui/Popover"
import { TbCircleFilled, TbInfoCircle } from "react-icons/tb"
import { t } from "i18next"
import { getCurrentState, getCurrentStateColor } from "../../../lib/calculations"
import { ScrollArea } from "@radix-ui/react-scroll-area"
import { ScrollBar } from "@/ui/ScrollArea/ScrollArea"
import { DateTime } from "luxon"

export default function MonitorShow({data}:{data: EventsCalculation}) {
    const {shifts} = useAppStore()
    const {dateShift} = useScreenStore()
    const currentShift = shifts.find(s => s.id === String(dateShift?.id!))

    return (
        <div className="flex flex-col gap-2">
        {dateShift && data.itemsData.map((item, index) => (
            <MonitorItem key={index} item={item} shift={currentShift!}/>
        ))}
        </div>
    )
}

function MonitorItem({item, shift}:{item: EventsCalculationItem, shift: FShift}) {
    const {persons} = useAppStore()
    const {isHistory} = useScreenStore()
    let currenState = item.events[item.events.length - 1][7] === 0 && item.events[item.events.length - 1][8] === "turned_off" ? getCurrentState(item.events[item.events.length - 2], item.equipment) : getCurrentState(item.events[item.events.length - 1], item.equipment)
    let person = item.events[item.events.length - 1][7] === 0 && item.events[item.events.length - 1][8] === "turned_off" ? persons?.find(p => p.id === String(item.events[item.events.length - 2][10])) : persons?.find(p => p.id === String(item.events[item.events.length - 1][10]))

    return (
        <div className="flex flex-col px-6">
            <div className="flex w-full pb-1 justify-between">
                <div className="flex text-sm font-medium items-center space-x-2">
                    <TbCircleFilled style={{color: getCurrentStateColor(currenState)}}/>
                    
                    <span className={`text-green-700 w-14`}>
                        {(item.availability.worked.percent * 100).toFixed(2)}%
                    </span> 
                    <span className={`text-amber-500 w-14`}>
                        {(item.availability.stopped.percent * 100).toFixed(2)}% 
                    </span>
                    {!isHistory && <span>
                        {person ? `${person.attributes.last_name} ${person.attributes.first_name} ${person.attributes.middle_name}` : ""}
                    </span>}
                </div>
                <div className="flex space-x-2 items-center">
                    <span>{item.equipment.attributes?.inventory_number}, {item.equipment.attributes?.name}</span>
                    <Popover>
                        <PopoverTrigger>
                            <TbInfoCircle />
                        </PopoverTrigger>
                        
                        <PopoverContent className="relative px-0" align="end">
                            <ScrollArea className="max-h-96 overflow-y-auto px-2">
                            {item.events.map((e: Event) => {
                                return (
                                    <div key={e[3]} className="text-sm">
                                        <div className="grid grid-cols-3">
                                            <span>{DateTime.fromSQL(String(e[3])).toFormat("HH:mm:ss")}</span>
                                            <span>{DateTime.fromSQL(String(e[5])).toFormat("HH:mm:ss")}</span>
                                            <span>{t(String(e[8]))}</span>
                                        </div>
                                    </div>
                                )
                            })}
                            <ScrollBar />
                            </ScrollArea>
                            {/* <div className="flex flex-col text-sm">
                                <span>{item.equipment.attributes?.inventory_number}</span>
                                <span>{item.equipment.attributes?.name}</span>
                                <span>{item.equipment.attributes?.producer_name}</span>
                                <span>{item.equipment.attributes?.equipment_model_name}</span>
                            </div> */}
                            
                        </PopoverContent>
                        
                    </Popover>
                </div>
            </div>
            <div className="border border-border inset-0 rounded">
                <TimelineChart events={item.events} shift={shift!} height={20} width="100%"/>
            </div>
        </div>
    )
}